import { Component, OnInit } from '@angular/core';
import {Profil} from '../../shared/profil';
import {AuthService} from '../../core/auth/auth.service';
import {AuthApiService} from '../../core/auth/auth-api.service';
import {Router} from '@angular/router';
import {ApiService} from '../../services/api.service';
import { LanguageService } from '../../services/language.service';
import { PermissionsService } from '../../core/permissions/permissions.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  userLogin: Profil = new Profil();
  logedUser: any = new Profil();

  constructor(
    private auth: AuthService,
    private authApi: AuthApiService,
    private myRoute: Router,
    public restApi: ApiService,
    private languageService: LanguageService,
    private permissionsService: PermissionsService,
  ){
  }

  ngOnInit(): void {

  }

  login() {
    if ( this.userLogin.login !== null ) {
      this.userExist( this.userLogin.login, this.userLogin.haslo );
    }
  }

  // Logowanie idzie przez nowy backend (AuthModule, patrz auth.service.ts) -
  // stary Profils/read_login.php nie jest juz uzywany.
  userExist( login: string, haslo: string ) {
    this.authApi.login(login, haslo).subscribe({
      next: (data) => {
        this.logedUser = data.user;
        localStorage.setItem('LoggedInUser', JSON.stringify(this.logedUser));
        this.auth.sendToken(data.access_token);
        this.languageService.init(this.logedUser.language);
        this.permissionsService.refresh().finally(() => this.myRoute.navigate(['home']));
      },
    });
  }
}
